import { render, staticRenderFns } from "./EditLayout.vue?vue&type=template&id=378c6062&scoped=true"
import script from "./EditLayout.vue?vue&type=script&lang=js"
export * from "./EditLayout.vue?vue&type=script&lang=js"
import style0 from "./EditLayout.vue?vue&type=style&index=0&id=378c6062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c6062",
  null
  
)

export default component.exports